export default class Message {
	constructor(text , target) {
		this.text = text;
		this.target = target;

	}

	init() {
		let msg = jQuery("#template-message").clone();
		msg.attr("id", "msg" + Message.ENUM++);
		msg.text(this.text);
		this.target.append(msg);
		this.target.scrollTop(10000);
		this.mc = msg;
		setTimeout(this.remove.bind(this), 3000);
	}

	remove() {
		this.mc.remove();
	}
}

Message.ENUM = 0;